import { render, staticRenderFns } from "./classifyTree.vue?vue&type=template&id=37750b3e&scoped=true"
import script from "./classifyTree.vue?vue&type=script&lang=js"
export * from "./classifyTree.vue?vue&type=script&lang=js"
import style0 from "./classifyTree.vue?vue&type=style&index=0&id=37750b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37750b3e",
  null
  
)

export default component.exports